export interface SituacaoOption {
  value: string;
  label: string;
}

export const SITUACOES_SCRIPT: SituacaoOption[] = [
  { value: "prospeccao", label: "Prospecção" },
  { value: "recepcao_abordagem", label: "Recepção/Abordagem" },
  { value: "sondagem", label: "Sondagem" },
  { value: "apresentacao", label: "Apresentação" },
  { value: "objecoes", label: "Objeções" },
  { value: "acompanhamento", label: "Acompanhamento" },
  { value: "fechamento", label: "Fechamento" },
  { value: "pos_venda", label: "Pós-venda" },
  { value: "indicacao", label: "Indicação" },
  { value: "reativacao", label: "Reativação" },
];

export function labelSituacao(value?: string | null): string {
  if (!value) return "";
  const found = SITUACOES_SCRIPT.find((s) => s.value === value);
  return found ? found.label : value;
}
